import { useMemo } from "react";
import { useSession } from "@/context/SessionProvider";

export function usePermisos() {
  const { user } = useSession();

  const config = useMemo(() => {
    if (!user?.config_json) return null;
    try {
      return typeof user.config_json === "string"
        ? JSON.parse(user.config_json)
        : user.config_json;
    } catch (error) {
      console.error("Error parsing config_json:", error);
      return null;
    }
  }, [user]);

  const hasMenuAccess = (menuId) => {
    if (!config?.menus_sidebar) return false;
    return config.menus_sidebar.includes(menuId);
  };

  const hasModuleAccess = (moduloId) => {
    if (!config?.modulosVisibles) return false;
    return config.modulosVisibles.includes(moduloId);
  };

  const canCreate = (moduloId) => {
    return config?.permisos?.[moduloId]?.create || false;
  };

  const canRead = (moduloId) => {
    return config?.permisos?.[moduloId]?.read || false;
  };

  const canUpdate = (moduloId) => {
    return config?.permisos?.[moduloId]?.update || false;
  };

  const canDelete = (moduloId) => {
    return config?.permisos?.[moduloId]?.delete || false;
  };

  return {
    config,
    hasMenuAccess,
    hasModuleAccess,
    canCreate,
    canRead,
    canUpdate,
    canDelete,
  };
}
